var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9669 6.02572V20.5827C18.9669 21.3656 18.3319 22 17.5497 22H4.45038C3.66753 22 3.03314 21.3656 3.03314 20.5827V1.41724C3.0331 0.634391 3.66749 0 4.45038 0H12.9412L18.9669 6.02572Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0737 11.0459H6.92572V11.9513H15.0737V11.0459Z",
    fill: "#DFDADA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0737 13.0684H6.92572V13.9738H15.0737V13.0684Z",
    fill: "#DFDADA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0737 15.0898H6.92572V15.9952H15.0737V15.0898Z",
    fill: "#DFDADA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7203 17.1123H6.92572V18.0177H12.7203V17.1123Z",
    fill: "#DFDADA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7633 5.89447L18.9669 8.03822V6.0254L16.0166 5.1543L13.7633 5.89447Z",
    fill: "#9F9FA0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9669 6.02572H14.3585C13.5756 6.02572 12.9412 5.39133 12.9412 4.60848V0L18.9669 6.02572Z",
    fill: "#D5D5D5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocs);
export default __webpack_public_path__ + "static/media/docs.b1fe4be440248aa39beb75f337277bdc.svg";
export { ForwardRef as ReactComponent };